import { FC, Fragment } from 'react'
import styles from './PerfectNightSleep.module.scss'
import { PerfectNightSleepProps, CardProps } from './types'

import { Img } from 'components/basic/Img'
import { Type } from 'components/Type'
import { useMetricRegion } from 'stores/settings'

export const BestTempYetConnected = () => {
	const metric = useMetricRegion()
	return <PerfectNightSleep metric={metric} />
}

const data = [
	{
		title: 'Biometric sensors',
		description: 'These algorithms take in data like chest vibrations, heart beats and respiration to determine health metrics and sleep stage.',
	},
	{
		title: 'Presence sensors',
		description: "These sensors detect presence so that Autopilot can determine if you're occupying your side of the Pod.",
	},
	{
		title: 'Environmental sensors',
		description: "These sensors detect your environmental temperature by sensing the room's temperature and humidity level.",
	},
]

export const PerfectNightSleep: FC<PerfectNightSleepProps> = (props) => {
	const { cards = data, ctaUrl = '/product/pod-cover' } = props
	return (
		<section className={styles.container}>
			<header className={styles.header}>
				<Type.Headline1 as={'h2'}>A perfect night's sleep with Autopilot</Type.Headline1>
			</header>
			<div className={styles.inner}>
				<Img
					className={styles.image}
					src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/bfcm_2024/new_perfect_sleep.jpeg"
					alt="A warmly lit bedroom"
				/>
				<article>
					<ul className={styles.cards}>
						{cards.map((card) => (
							<Fragment key={card.title}>
								<Card {...card} />
							</Fragment>
						))}
					</ul>
				</article>
			</div>
		</section>
	)
}

const Card: FC<CardProps> = (props) => {
	const { title = '2x', description = 'Twice as powerful as the previous Pod generation.' } = props

	return (
		<li className={styles.card}>
			<Type.Headline6 as={'h3'}>{title}</Type.Headline6>
			<Type.Body2>{description}</Type.Body2>
		</li>
	)
}
